<template lang="pug">
  shListData(title="Cambios" resolver="changes" keyData="change" component="shChange")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Changes',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/change/Changes.vue